import { useState, useEffect } from 'react';

interface PopupLoginOptions {
  width?: number;
  height?: number;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

interface PopupLoginResult {
  openPopup: () => void;
  closePopup: () => void;
  isOpen: boolean;
  error: any | null;
}

export const usePopupLogin = (options: PopupLoginOptions = {}): PopupLoginResult => {
  const [popup, setPopup] = useState<Window | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState<any | null>(null);

  const {
    width = 500,
    height = 700,
    onSuccess,
    onError
  } = options;

  useEffect(() => {
    if (!popup) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;

      try {
        if (event.data.success) {
          onSuccess?.(event.data);
          closePopup();
        } else if (event.data.error) {
          setError(event.data.error);
          onError?.(event.data.error);
          closePopup();
        }
      } catch (err) {
        setError(err);
        onError?.(err);
        closePopup();
      }
    };

    const handlePopupClose = () => {
      if (!popup.closed) return;
      closePopup();
    };

    const checkInterval = setInterval(handlePopupClose, 500);

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
      clearInterval(checkInterval);
    };
  }, [popup, onSuccess, onError]);

  const openPopup = () => {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    const newPopup = window.open(
      '/popup-login',
      '로그인',
      `width=${width},height=${height},left=${left},top=${top}`
    );

    if (newPopup) {
      setPopup(newPopup);
      setIsOpen(true);
      setError(null);
    } else {
      setError(new Error('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.'));
      onError?.(new Error('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.'));
    }
  };

  const closePopup = () => {
    if (popup && !popup.closed) {
      popup.close();
    }
    setPopup(null);
    setIsOpen(false);
  };

  return {
    openPopup,
    closePopup,
    isOpen,
    error
  };
}; 